import React  from "react";
import { Controller, useFormContext } from "react-hook-form";

const Input = ({
  label,
  name,
  type = "text",
  placeholder,
  divStyle,
  className = "",
  maxLength,
  control,
  rules = {},
  showError = true,
  ...rest
}) => {
  const { register,  formState: { errors }, } = useFormContext();
  

  return (
    <div style={divStyle}>
      {label && (
        <label htmlFor={name} className="input-label">
          {label}
        </label>
      )}
      {control ? (
        <Controller
          name={name}
          control={control}
          rules={rules}
          render={({ field }) => (
            <input
              id={name}
              type={type}
              placeholder={placeholder}
              className={className}
              maxLength={maxLength}
              {...field}
              {...rest}
            />
          )}
        />
      ) : (
        <input
          id={name}
          name={name}
          type={type}
          placeholder={placeholder}
          {...register(name, rules)}
          className={className}
          maxLength={maxLength}
          {...rest}
        />
      )}
      {showError && errors[name] && (
        <p
          className="error-message"
          style={{ color: "red", marginTop: "4px", fontSize: "0.85em" }}
        >
          {errors[name].message}
        </p>
      )}
    </div>
  );
};

export default Input;
